import {bzApi} from '@/axios'
// 查询项目列表
export function projectList(sendData) {
    return bzApi({
        url: '/project/page',
        method: 'post',
        data: sendData
    })
}

// 导出项目
export function projectExport() {
    return bzApi({
        url: '/project/export/all',
        method: 'get',
        responseType: "blob"
    })
}


// 释放原始数据
export function projectRelease(id) {
    return bzApi({
        url: '/project/verifyRawData/'+id,
        method: 'get',
    })
}

// 删除项目
export function projectDel(id) {
    return bzApi({
        url: '/project/' + id,
        method: 'delete'
    })
}
// 编辑项目信息（类型+备注）
export function projectEdit(data) {
    return bzApi({
        url: '/project',
        method: 'put',
        data:data
    })
}
export function projectCustomerEdit(data) {
    return bzApi({
        url: '/project/customer/remark',
        method: 'put',
        data:data
    })
}
// / 更改项目的用户
export function projectChangeUser(data) {
    return bzApi({
        url: '/project/editUsers',
        method: 'put',
        data:data
    })
}
// 最后10条
export function projectLast_10_bz(){
    return bzApi({
        url: '/project/last-10?systemType=diversity',
        method: 'get',
    })
}
export function projectLast_10_bz_fun(){
    return bzApi({
        url: '/project/last-10?systemType=funcGene',
        method: 'get',
    })
}

export function projectMerge(sendData){
    return bzApi({
        url: 'amplicon-server/project/projectMerge',
        method: 'post',
        data: sendData
    })
}

export function analyzeItemListByProjects(sendData){
    return bzApi({
        url: '/analyze/analyzeItemListByProjects',
        method: 'post',
        data: sendData
    })
}

export function customerProjectsBySalesName(sendData){
    return bzApi({
        url: '/project/customer-projects-by-sales',
        method: 'post',
        data: sendData
    })
}

export function projectLivenessPage(sendData){
    return bzApi({
        url: '/project/projectLivenessPage',
        method: 'post',
        data: sendData
    })
}

export function customerLivenessPage(sendData){
    return bzApi({
        url: '/project/customerLivenessPage',
        method: 'post',
        data: sendData
    })
}
